import { commentCreatedBIEventListener } from './commentCreatedBIEventListener';
import {homeDeliverySelectedBIEventListener} from './homeDeliverySelectedBIEventListener.js';
import {pointDeliverySelectedBIEventListener} from './pointDeliverySelectedBIEventListener.js';
import { offerCreatedBIEventListener } from './offerCreatedBIEventListener';
import { offerResponseBIEventListener } from './offerResponseBIEventListener';
import { productRepublishBIEventListener } from './productRepublishBIEventListener';
import { userFollowBIEventListener } from './userFollowBIEventListener';
import { addToCartBIEventListener } from './addToCartBIEventListener';

export const initBIEventListeners = () => {
    commentCreatedBIEventListener();
    homeDeliverySelectedBIEventListener();
    pointDeliverySelectedBIEventListener();
    offerCreatedBIEventListener();
    offerResponseBIEventListener();
    productRepublishBIEventListener();
    userFollowBIEventListener();
    addToCartBIEventListener();
}
